import React from 'react';
import { Loader } from 'freemium-ui';
import qs from 'query-string';
import { useLocation, useParams } from 'react-router-dom';
import { Center } from '../../../shared/styles';

const FreshidSigupSuccess = () => {
  const { authToken }: any = useParams();
  const routerLocation = useLocation();
  const { rt }: any = qs.parse(routerLocation.search);

  React.useEffect(() => {
    const decodedToken = atob(authToken);
    console.log('FreshidSigupSuccess');
    localStorage.setItem('authToken', decodedToken);
    if (rt) {
      const decodedRfToken = atob(rt);
      localStorage.setItem('rfToken', decodedRfToken);
    }
    window.location.href = '/app/survey/create?onboarding=1';
  }, []);

  return (
    <Center>
      <Loader />
    </Center>
  );
};

export default FreshidSigupSuccess;
